import React from 'react';
import { UserManagement } from '../components';

const UsersPage = ({ user }) => {
  return (
    <div className="space-y-6">
      {/* Header da Página */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Gerenciamento de Usuários</h1>
            <p className="text-gray-600">
              Gerencie usuários, permissões e configurações do sistema
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
              {user?.role === 'admin' ? 'Administrador' : 'Gerente'}
            </span>
          </div>
        </div>
      </div>
      
      {/* Conteúdo da Página */}
      <UserManagement user={user} />
    </div>
  );
};

export default UsersPage;
